let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iGEeG")).then(() => parcelRequire('3EgOL'));